module.exports = __webpack_public_path__ + "static/media/parth.2e7c1a7a.jpg";